import { render, staticRenderFns } from "./ActionCoordinatorsCard.vue?vue&type=template&id=afbcf7ac&"
import script from "./ActionCoordinatorsCard.vue?vue&type=script&lang=js&"
export * from "./ActionCoordinatorsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports